import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {FontAwesomeService} from '@services/font-awesome.service';
import {Option} from '@models/select-dropdown-option.interface';
import {Subscription} from 'rxjs/Subscription';
import {CustomsDataDocumentTypeEnum} from '@models/customs-data-document-type-enum';

@Component({
  selector: 'app-customs-form',
  templateUrl: './customs-form.component.html',
  styleUrls: ['./customs-form.component.scss']
})

export class CustomsFormComponent implements OnInit {
  public showMoreInfoText = false;
  @Input() parent: FormGroup;
  @Input() submitted: boolean;
  @Input() product_id: number;
  @Input() filters: any;
  @Output() updateFormData: EventEmitter<any> = new EventEmitter();

  public documentTypes: Array<Option> = [];
  public currencies: Array<Option> = [
    'SEK',
    'DKK',
    'NOK',
    'EUR',
    'USD',
    'GBP',
  ].map(value => ({value: value, label: value}));

  constructor(
    public faService: FontAwesomeService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.documentTypes = [
      {
        'label': this.translate.instant('account.section.createConsignment.form.customs.commercialInvoice'),
        'value': CustomsDataDocumentTypeEnum.COMMERCIAL
      },
      {
        'label': this.translate.instant('account.section.createConsignment.form.customs.proformaInvoice'),
        'value': CustomsDataDocumentTypeEnum.PROFORMA
      }
    ];
  }

  static generateForm() {
    return new FormGroup({
      document_type: new FormControl('', [Validators.required]),
      invoice_number: new FormControl('', [Validators.required]),
      invoice_date: new FormControl('', [Validators.required]),
      statistical_number: new FormControl('', [Validators.required]),
      total_declared_value: new FormControl('', [Validators.required]),
      currency: new FormControl('SEK', [Validators.required]),
    });
  }

  toggleMoreInfoText() {
    this.showMoreInfoText = !this.showMoreInfoText;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/search/components/customs-form/customs-form.component.ts